<script setup lang="ts">
defineProps<{
  noFloat?: boolean;
}>();
</script>

<template>
  <div v-if="!noFloat" class="loading-spinner card">
    <div class="loading-icon"></div>

    Laster inn
  </div>

  <div v-else>
    <div class="loading-icon"></div>
  </div>
</template>

<style scoped>
.loading-spinner {
  position: fixed;
  top: var(--gap-md);
  padding: var(--gap-md);
  width: auto;
  left: 50%;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--gap-md);
  z-index: 2;
}

.loading-icon-wrapper {
  position: absolute;
  width: 100%;
  padding: 1rem 0;
  pointer-events: none;
}

.loading-icon {
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  z-index: 10000;
  box-shadow: inset 0 0 0 0.125em lightgray;
  pointer-events: none;
}

.loading-icon::before,
.loading-icon::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 0.125rem solid gray;
  border-left-color: transparent;
  border-top-color: transparent;
}

.loading-icon::before {
  animation: rotate 1s infinite linear;
}

.loading-icon::after {
  animation: rotate 0.75s infinite linear;
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}
</style>
